import { PostingModel } from "app/models/PostModel";
import { usePostingFormBase } from "app/utils/hooks/usePostingFormBase";
import { shallowEqual, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "typedefs";

interface Props {
  onPost?: (post: PostingModel) => void;
}

export const useSpacePostingForm = ({ onPost }: Props) => {
  const spaceParams = useParams<{ id: string }>();

  const { selectedSpace } = useSelector(
    (state: RootState) => state.space,
    shallowEqual,
  );

  const { user, canSchedulePosts, canUploadMedia, postActions } =
    usePostingFormBase({
      entityPlanPermissions: selectedSpace?.planPermissions,
    });

  const onSubmit = (data: PostingModel) => {
    if (selectedSpace) {
      postActions
        .createPost({ ...data, space_id: [spaceParams?.id] })
        .then((res) => {
          if (res && onPost) {
            onPost(res);
          }
        });
    }
  };

  return {
    canUploadMedia,
    user,
    onSubmit,
    canSchedulePosts,
  };
};
